import * as React from "react";
import Grid from "@mui/material/Grid"; 
import { CmpTypographyField } from "../../Component/Common/ToolBox/ToolBox";
export const LoadingDetailCard = ({
  SrNo='',
  LoadingBay='',    
  BarCode='',
  Qty='',
  Unit='', 
  BaseQty='', 
  ItemName='',
  onClick='',
}) => {
  let xsLabel = 2.2; 
  let xsColon = 0.2;
  let xsValue =3.6; 

  let mdLabel = 3; 
  let mdColon = 0.5;
  let mdValue = 2.5;
  let mdItemValue = 8;
  return (
    <Grid
      container
      spacing={0}
      rowSpacing={0}
      columnSpacing={0}
      sx={{
        // border: "1px solid black",
        borderWidth: "1px 1px 1px 5px",
        borderStyle: "solid solid solid solid",
        borderRadius: "0px 10px 10px 0px",
        padding: "1px 2px 2px 8px",
        marginTop: "2px",
        borderColor: "#0d73bb",
         
        // border-width: 1px 1px 1px 3px;
        // border-style: double double double solid;
      }}
      columns={{ xs: 12, sm: 12, md: 12 }}
      onClick={onClick}
      className="PickingDetailCard"
    >
        <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"SrNo"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue} md={mdValue}>
        <CmpTypographyField xcomponent={"span"} xText={SrNo} />
      </Grid>
      
       

      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={" Barcode"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue} md={mdValue}>
        <CmpTypographyField xcomponent={"span"} xText={BarCode} />
      </Grid>
      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"Bin"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue} md={mdValue}>
        <CmpTypographyField xcomponent={"span"} xText={LoadingBay} />
      </Grid> 

      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"Qty"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue} md={mdValue}>
        <CmpTypographyField xcomponent={"span"} xText={Qty} />
      </Grid>
      {/* <Grid item xs={3} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"Bin.Name"} />
      </Grid>
      <Grid item xs={0.1} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={8.9} md={mdItemValue}>
        <CmpTypographyField
          xcomponent={"span"}
          xText={BarCode}
        />
      </Grid> */}

      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={" Unit"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue} md={mdValue}>
        <CmpTypographyField xcomponent={"span"} xText={Unit} />
      </Grid>
      
      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"BaseQty"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue  } md={mdValue}>
        <CmpTypographyField xcomponent={"span"} xText={BaseQty} />
      </Grid>
        
      <Grid item xs={xsLabel} md={mdLabel}>
        <CmpTypographyField xcomponent={"span"} xText={"Item"} />
      </Grid>
      <Grid item xs={xsColon} md={mdColon}>
        <CmpTypographyField xcomponent={"span"} xText={":"} />
      </Grid>
      <Grid item xs={xsValue +6} md={mdItemValue}>
        <CmpTypographyField
          xcomponent={"span"}
          xText={ItemName}
        />
      </Grid>
    </Grid>
  );
};
